// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__X4YOv","sm":"styles_sm__LzDPd","md":"styles_md__JdvIl","xl":"styles_xl__z+77f"};